module.exports = __webpack_public_path__ + "img/completed.27bfe1d1.svg";